module.exports = __webpack_public_path__ + "images/emoji/dash.efd992fbc868bb124fcd.png";